import { render, staticRenderFns } from "./ipList.vue?vue&type=template&id=2e42db34&scoped=true&"
import script from "./ipList.vue?vue&type=script&lang=js&"
export * from "./ipList.vue?vue&type=script&lang=js&"
import style0 from "./ipList.vue?vue&type=style&index=0&id=2e42db34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42db34",
  null
  
)

export default component.exports